var _style, _rect, _rect2, _rect3, _rect4, _circle, _rect5, _path, _circle2, _rect6, _rect7, _circle3, _rect8, _rect9, _rect10, _rect11, _rect12, _circle4, _rect13, _path2, _circle5, _rect14, _rect15, _circle6, _rect16, _rect17, _rect18, _rect19, _rect20, _circle7, _rect21, _path3, _circle8, _rect22, _rect23, _circle9, _rect24, _rect25, _rect26, _rect27, _rect28, _circle10, _rect29, _path4, _circle11, _rect30, _rect31, _circle12, _rect32, _rect33, _rect34, _rect35, _rect36, _circle13, _rect37, _path5, _circle14, _rect38, _rect39, _circle15, _rect40, _rect41, _rect42, _rect43, _rect44, _circle16, _rect45, _path6, _circle17, _rect46, _rect47, _circle18, _rect48, _rect49, _rect50, _rect51, _rect52, _circle19, _rect53, _path7, _circle20, _rect54, _rect55, _circle21, _rect56, _rect57, _rect58, _rect59, _rect60, _circle22, _rect61, _path8, _circle23, _rect62, _rect63, _circle24, _rect64, _rect65, _rect66, _rect67, _rect68, _circle25, _rect69, _path9, _circle26, _rect70, _rect71, _circle27, _rect72, _rect73, _rect74;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaimLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1034,
    height: 552,
    viewBox: "0 0 1034 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    @keyframes fade {\n        0% {\n            opacity: 1;\n        }\n\n        50% {\n              opacity: .5;\n\n        }\n\n        100% {\n             opacity: 1;\n\n        }\n    }\n    rect[fill=\"#E8E9F0\"], circle[fill=\"#E8E9F0\"] { animation: fade 1.5s infinite; }\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1033,
    height: 551,
    rx: 15.5,
    fill: "#FCFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 33.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 60.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 52,
    r: 9,
    fill: "#E8E9F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 46,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 51.7525C528.05 51.8892 528.05 52.1108 527.914 52.2475L525.686 54.4749C525.549 54.6116 525.328 54.6116 525.191 54.4749C525.054 54.3382 525.054 54.1166 525.191 53.9799L527.171 52L525.191 50.0201C525.054 49.8834 525.054 49.6618 525.191 49.5251C525.328 49.3884 525.549 49.3884 525.686 49.5251L527.914 51.7525ZM527.666 52.35H513.666V51.65H527.666V52.35Z",
    fill: "#D0D3E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 52,
    r: 9,
    fill: "#E8E9F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 46,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 46,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 52,
    r: 9,
    fill: "#E8E9F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 46,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 35.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 90,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 89.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 116.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 108,
    r: 9,
    fill: "#E8E9F0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 102,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 107.753C528.05 107.889 528.05 108.111 527.914 108.247L525.686 110.475C525.549 110.612 525.328 110.612 525.191 110.475C525.054 110.338 525.054 110.117 525.191 109.98L527.171 108L525.191 106.02C525.054 105.883 525.054 105.662 525.191 105.525C525.328 105.388 525.549 105.388 525.686 105.525L527.914 107.753ZM527.666 108.35H513.666V107.65H527.666V108.35Z",
    fill: "#D0D3E0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 108,
    r: 9,
    fill: "#E8E9F0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 102,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 102,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 108,
    r: 9,
    fill: "#E8E9F0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 102,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 91.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 146,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 145.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 172.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 164,
    r: 9,
    fill: "#E8E9F0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 158,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 163.753C528.05 163.889 528.05 164.111 527.914 164.247L525.686 166.475C525.549 166.612 525.328 166.612 525.191 166.475C525.054 166.338 525.054 166.117 525.191 165.98L527.171 164L525.191 162.02C525.054 161.883 525.054 161.662 525.191 161.525C525.328 161.388 525.549 161.388 525.686 161.525L527.914 163.753ZM527.666 164.35H513.666V163.65H527.666V164.35Z",
    fill: "#D0D3E0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 164,
    r: 9,
    fill: "#E8E9F0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 158,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 158,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 164,
    r: 9,
    fill: "#E8E9F0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 158,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 147.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 202,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 201.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 228.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 220,
    r: 9,
    fill: "#E8E9F0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 214,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 219.753C528.05 219.889 528.05 220.111 527.914 220.247L525.686 222.475C525.549 222.612 525.328 222.612 525.191 222.475C525.054 222.338 525.054 222.117 525.191 221.98L527.171 220L525.191 218.02C525.054 217.883 525.054 217.662 525.191 217.525C525.328 217.388 525.549 217.388 525.686 217.525L527.914 219.753ZM527.666 220.35H513.666V219.65H527.666V220.35Z",
    fill: "#D0D3E0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 220,
    r: 9,
    fill: "#E8E9F0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 214,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 214,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 220,
    r: 9,
    fill: "#E8E9F0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 214,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 203.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 258,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 257.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 284.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 276,
    r: 9,
    fill: "#E8E9F0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 270,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 275.753C528.05 275.889 528.05 276.111 527.914 276.247L525.686 278.475C525.549 278.612 525.328 278.612 525.191 278.475C525.054 278.338 525.054 278.117 525.191 277.98L527.171 276L525.191 274.02C525.054 273.883 525.054 273.662 525.191 273.525C525.328 273.388 525.549 273.388 525.686 273.525L527.914 275.753ZM527.666 276.35H513.666V275.65H527.666V276.35Z",
    fill: "#D0D3E0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 276,
    r: 9,
    fill: "#E8E9F0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 270,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 270,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 276,
    r: 9,
    fill: "#E8E9F0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 270,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 259.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 314,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 313.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 340.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 332,
    r: 9,
    fill: "#E8E9F0"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 326,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 331.753C528.05 331.889 528.05 332.111 527.914 332.247L525.686 334.475C525.549 334.612 525.328 334.612 525.191 334.475C525.054 334.338 525.054 334.117 525.191 333.98L527.171 332L525.191 330.02C525.054 329.883 525.054 329.662 525.191 329.525C525.328 329.388 525.549 329.388 525.686 329.525L527.914 331.753ZM527.666 332.35H513.666V331.65H527.666V332.35Z",
    fill: "#D0D3E0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 332,
    r: 9,
    fill: "#E8E9F0"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 326,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 326,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 332,
    r: 9,
    fill: "#E8E9F0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 326,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 315.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 370,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 369.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 396.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 388,
    r: 9,
    fill: "#E8E9F0"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 382,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 387.753C528.05 387.889 528.05 388.111 527.914 388.247L525.686 390.475C525.549 390.612 525.328 390.612 525.191 390.475C525.054 390.338 525.054 390.117 525.191 389.98L527.171 388L525.191 386.02C525.054 385.883 525.054 385.662 525.191 385.525C525.328 385.388 525.549 385.388 525.686 385.525L527.914 387.753ZM527.666 388.35H513.666V387.65H527.666V388.35Z",
    fill: "#D0D3E0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 388,
    r: 9,
    fill: "#E8E9F0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 382,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 382,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 388,
    r: 9,
    fill: "#E8E9F0"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 382,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 371.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 426,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 425.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 452.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 444,
    r: 9,
    fill: "#E8E9F0"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 438,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 443.753C528.05 443.889 528.05 444.111 527.914 444.247L525.686 446.475C525.549 446.612 525.328 446.612 525.191 446.475C525.054 446.338 525.054 446.117 525.191 445.98L527.171 444L525.191 442.02C525.054 441.883 525.054 441.662 525.191 441.525C525.328 441.388 525.549 441.388 525.686 441.525L527.914 443.753ZM527.666 444.35H513.666V443.65H527.666V444.35Z",
    fill: "#D0D3E0"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 444,
    r: 9,
    fill: "#E8E9F0"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 438,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 438,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 444,
    r: 9,
    fill: "#E8E9F0"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 438,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 427.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 482,
    width: 52,
    height: 36,
    rx: 8,
    fill: "#E8E9F0"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 481.5,
    width: 160,
    height: 19,
    rx: 9.5,
    fill: "#E8E9F0"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 508.5,
    width: 137,
    height: 10,
    rx: 5,
    fill: "#E8E9F0"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.666,
    cy: 500,
    r: 9,
    fill: "#E8E9F0"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 393.666,
    y: 494,
    width: 108,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M527.914 499.753C528.05 499.889 528.05 500.111 527.914 500.247L525.686 502.475C525.549 502.612 525.328 502.612 525.191 502.475C525.054 502.338 525.054 502.117 525.191 501.98L527.171 500L525.191 498.02C525.054 497.883 525.054 497.662 525.191 497.525C525.328 497.388 525.549 497.388 525.686 497.525L527.914 499.753ZM527.666 500.35H513.666V499.65H527.666V500.35Z",
    fill: "#D0D3E0"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.666,
    cy: 500,
    r: 9,
    fill: "#E8E9F0"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 565.666,
    y: 494,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 765.333,
    y: 494,
    width: 39,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 500,
    r: 9,
    fill: "#E8E9F0"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 494,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#E8E9F0"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 889.5,
    y: 483.5,
    width: 120,
    height: 33,
    rx: 16.5,
    stroke: "#D0D3E0"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1033,
    height: 551,
    rx: 15.5,
    stroke: "#F0F1FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimLoading);
export default __webpack_public_path__ + "static/media/claim-loading.58479ad78eabaa5c0ab01c426e85d778.svg";
export { ForwardRef as ReactComponent };